import React from "react";
const IconTrash = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16" {...props}>
    <path
      d="m4.906 4.802.8 8.8h6.4l.8-8.8m-8 0h-1.6m1.6 0h1.6m6.4 0h1.6m-1.6 0h-1.6m-4.8 0v-2.4h4.8v2.4m-4.8 0h4.8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconTrash;
